'use strict';

var _ = require('lodash');
var d3 = require('d3');
var ScaleBuilder = function ScaleBuilder(yScale) {
  return function (params, data) {
    var x = d3.scale.ordinal().domain(_.map(data, 'd1')).rangeBands([0, params.width], 0, 0);
    return {
      xScale: x,
      yScale: yScale
    };
  };
};
module.exports = ScaleBuilder;